//auth
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
export const JWT_REGISTER = "/post-jwt-register";
export const POST_FAKE_REGISTER = "/post-fake-register";

export const USER_CHANGE_PASSWORD = "/user-change-password";

//auth
export const GENERATE_JWT = "/api/login/generate-jwt";
export const LOGOUT = "/api/login/logout";

// profile & settings
export const CREATE_PROFILE = "/api/profile/create-profile";
export const UPDATE_PROFILE = "/api/profile/update-profile";
export const GET_PROFILE = "/api/profile/get-profile";
export const UPLOAD_LOGO = "/api/profile/upload-logo";

//client
export const CREATE_CLIENT = "/api/client/create-client";
export const UPDATE_CLIENT = "/api/client/update-client";
export const GET_CLIENT = "/api/client/get-client";
export const GET_ALL_CLIENTS = "/api/client/get-all-clients";
export const DELETE_CLIENT = "/api/client/delete-client";
export const DELETE_CLIENTS = "/api/client/delete-clients";

//product
export const CREATE_UNIT = "/api/product/create-unit";
export const CREATE_VAT = "/api/product/create-vat";
export const GET_ALL_UNITS = "/api/product/get-all-units";
export const GET_ALL_VATS = "/api/product/get-all-vats";
export const CREATE_PRODUCT = "/api/product/create-product";
export const GET_ALL_PRODUCTS = "/api/product/get-all-products";
export const GET_PRODUCT = "/api/product/get-product";
export const DELETE_PRODUCT = "/api/product/delete-product";
export const DELETE_PRODUCTS = "/api/product/delete-products";
export const UPDATE_PRODUCT = "/api/product/update-product";

//invoice
export const CREATE_INVOICE = "/api/invoice/create-invoice";
export const GET_ALL_INVOICES = "/api/invoice/get-all-invoices";
export const GET_INVOICE = "/api/invoice/get-invoice";
export const UPDATE_INVOICE = "/api/invoice/update-invoice";
export const DELETE_INVOICE = "/api/invoice/delete-invoice";
export const MARK_SENT = "/api/invoice/mark-sent";
export const MARK_PAID = "/api/invoice/mark-paid";
export const MARK_CANCEL = "/api/invoice/mark-cancel";
export const DELETE_ALL_INVOICES = "/api/invoice/delete-all-invoice";
export const GENERATE_INVOICE_PDF = "/api/invoice/generate-invoice-pdf";
export const SEND_EMAIL_INVOICE = "/api/invoice/send-email-invoice";
export const DELETE_SELECTED_INVOICES = "/api/invoice/delete-selected-invoices";

//email template
export const CREATE_EMAIL_TEMPLATE = "/api/template/create-email-template";
export const UPDATE_EMAIL_TEMPLATE = "/api/template/update-email-template";
export const DELETE_EMAIL_TEMPLATE = "/api/template/delete-email-template";
export const GET_ALL_EMAIL_TEMPLATES = "/api/template/get-all-templates";
export const GET_EMAIL_TEMPLATE = "/api/template/get-template";

//subscription
export const CREATE_SUBSCRIPTION = "/api/subscription/create-subscription";
export const CREATE_PAYMENT_INTENT = "/api/subscription/create-payment-intent";
export const PROCESS_PAYMENT = "/api/subscription/process-payment";
export const SAVE_SUBSCRIPTION_INFO =
  "/api/subscription/save-subscription-info";
export const CANCEL_SUBSCRIPTION = "/api/subscription/cancel-subscription";
export const CHECK_PAYMENTDATE = "/api/subscription/check-paymentdate";

// contacts
export const SEND_CONTACT = "/api/contact/send-contact";
export const GET_CONTACTS = "/user-contacts";
export const INVITE_CONTACT = "/invite-contact";

// calls
export const GET_CALLS_LIST = "/calls-list";

// bookmarks
export const GET_BOOKMARKS_LIST = "/bookmarks-list";
export const DELETE_BOOKMARK = "/bookmarks-delete";
export const UPDATE_BOOKMARK = "/bookmarks-update";

// chats
export const GET_FAVOURITES = "/get-favourites";
export const GET_DIRECT_MESSAGES = "/get-direct-messages";
export const GET_CHANNELS = "/get-channles";
export const ADD_CONTACTS = "/add-contact";
export const CREATE_CHANNEL = "/create-channel";
export const GET_CHAT_USER_DETAILS = "/get-user-details";
export const GET_CHAT_USER_CONVERSATIONS = "/get-user-conversations";
export const SEND_MESSAGE = "/send-message";
export const RECEIVE_MESSAGE = "/receive-message";
export const READ_MESSAGE = "/read-message";
export const RECEIVE_MESSAGE_FROM_USER = "/receive-message-from-user";
export const DELETE_MESSAGE = "/delete-message";
export const FORWARD_MESSAGE = "/forward-message";
export const DELETE_USER_MESSAGES = "/delete-user-messages";
export const TOGGLE_FAVOURITE_CONTACT = "/toggle-favourite-contact";
export const GET_ARCHIVE_CONTACT = "/get-archive-contacts";
export const TOGGLE_ARCHIVE_CONTACT = "/toggle-archive-contact";
export const READ_CONVERSATION = "/read-conversation";
export const DELETE_IMAGE = "/user-delete-img";

// groups
export const GET_CHANNEL_DETAILS = "/get-channel-details";
